import { Dialog, MenuItem, Select } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import toastr from 'toastr';
import swal from 'sweetalert';
import { allMetricsListStart } from '../../../../../../redux/athlete/dashboard/editUserProfile/stats/allMetrics';
import {
  allStatMatricDetailsListSave,
  allStatMatricDetailsListStart,
} from '../../../../../../redux/athlete/dashboard/editUserProfile/stats/allStatmatrixdetails';
import { saveVideoPhotoStart } from '../../../../../../redux/athlete/dashboard/editUserProfile/photo-video/saveVideoPhoto';
import { saveStatsMatrixDetailsStart } from '../../../../../../redux/athlete/dashboard/editUserProfile/stats/saveStatsMatrixDetails';
import { getUserInfo } from '../../../../../../services/authService';
import InlineLoader from '../../../../../common/InlineLoader';
import {
  athleteHeightWeightSaveStart,
  athleteHeightWeightStart,
} from '../../../../../../redux/athlete/onBoarding/athleteheightandweights';
import {
  AddYardModalMetrics,
  DeleteVideoModal,
  UploadedVideoReview,
  UploadVideoModal,
  WebLinkModal,
  DeleteWeblinkModal,
} from './Components';
import {
  fetchMethod,
  fetchGraphMethod,
} from '../../../../../../services/httpService';
import {
  fetchAllMetricsWithDetailsQuery,
  fetchAllStatMetricsDetailsQuery,
  saveStatmatrixdetails,
} from './statsQuery';
import { getAthleteHeightWeight } from '../../../onboarding/OnboardingQuery';
import { getUTCTimeDateOverall } from '../../../../../../utils/dateTimeFormatter';
import { saveOnboardingStart } from '../../../../../../redux/athlete/onBoarding/onboarding';
import { sendStatsNotification } from '../../../../../../utils/sendNotificationToAdvisor';
import { calculate1RM } from './calculate1RM';

const getMetricLabel = (tabSelect, isEdit, handeIsEdit, metricData) => {
  switch (
    tabSelect.tabData && tabSelect.tabData.statsmatrixid
      ? tabSelect.tabData.statsmatrixid
      : ''
  ) {
    case 1:
      return isEdit ? (
        <a>
          <span>{`${metricData.result} ${tabSelect.tabData.unit} `} </span>
        </a>
      ) : (
        `${metricData.result} ${tabSelect.tabData.unit}`
      );
    case 2:
      return isEdit ? (
        <a>
          <span>
            {metricData.jumpincentimeter ? metricData.jumpincentimeter : ''} cm
            ,
            {`${metricData.statmatrixdetailsjumbidinfeetmaprel.Feet[0].feetvalue}' ${metricData.statmatrixdetailsjumbidininchesmaprel.Inches[0].inchvalue}"`}{' '}
          </span>
        </a>
      ) : (
        ` ${
          metricData.jumpincentimeter ? metricData.jumpincentimeter : ''
        } cm , ${
          metricData.statmatrixdetailsjumbidinfeetmaprel.Feet[0].feetvalue
        }' ${
          metricData.statmatrixdetailsjumbidininchesmaprel.Inches[0].inchvalue
        }"`
      );
    case 3:
      return isEdit ? (
        <a>
          <span>{`${metricData.result} ${tabSelect.tabData.unit} `} </span>
        </a>
      ) : (
        `${metricData.result} ${tabSelect.tabData.unit}`
      );
    default:
      return isEdit ? (
        <a>
          <span>{`${metricData.result} ${tabSelect.tabData.unit} `} </span>
        </a>
      ) : (
        `${metricData.result} ${
          tabSelect.tabData && tabSelect.tabData.unit
            ? tabSelect.tabData.unit
            : ''
        }`
      );
  }
};

const Metrics = (props) => {
  const [toggleId, setToggleId] = useState(0);
  const [toggleValue, settoggleValue] = useState(false);
  const [toggleValueArray, settoggleValueArray] = useState([]);
  const [metricList, setMetricList] = useState([]);
  const [statMetricDetailsList, setStatMetricDetailsList] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showAddVideoModal, setShowAddVideoModal] = useState(false);
  const [showDeleteVideoModal, setShowDeleteVideoModal] = useState(false);
  const [isEdit, setisEdit] = useState(false);
  const [tabSelect, setTabSelect] = useState({
    id: '',
    tabname: '',
    tabId: '',
    isData: false,
  });
  const [metricSelect, setMetricSelect] = useState({});
  const [isAdd, setIsAdd] = useState(true);
  const [showVideoReviewPopup, setShowVideoReviewPopup] = useState(false);
  const [openLinkPop, setOpenLinkPop] = useState(false); //state for open and close popup
  const [webLinkState, setWebLinkState] = useState(null); //state for weblink data
  const [isValid, setIsValid] = useState(false); //state for validation
  const [matData, setMatData] = useState(null);
  const [isDelPop, setIsDelPop] = useState(false); //state for delete pop

  useEffect(() => {
    settoggleValueArray([]);
  }, [props.activeTab]);

  const handeIsEdit = (metricData) => {
    setMetricSelect(metricData);
    setisEdit(true);
    setIsAdd(false);
    showAddModalHandler();
  };

  const editHandler = () => {
    setisEdit(false);
  };
  const handleToggleId = (id) => {
    if (toggleValueArray.includes(id) == false) {
      const newToggleArray = [...toggleValueArray];
      newToggleArray.push(id);
      setisEdit(false);
      //setToggleId(toggleValue == false ? id : 0);
      setToggleId(id);
      settoggleValue(!toggleValue);
      settoggleValueArray(newToggleArray);
    } else {
      const newToggleArray = [...toggleValueArray];
      const newToggleupdatedArray = newToggleArray.filter(
        (item) => item !== id
      );
      setisEdit(false);
      //setToggleId(toggleValue == false ? id : 0);
      setToggleId(0);
      settoggleValue(!toggleValue);
      settoggleValueArray(newToggleupdatedArray);
    }
  };
  const addDataFirstTime = () => {
    setIsAdd(true);
    showAddModalHandler();
  };
  const showAddModalHandler = async () => {
    await setShowAddModal(!showAddModal);
  };
  const AddAnotherDataBar = () => {
    setIsAdd(true);
    const showData = [];
    statMetricDetailsList.map((metricDetail) => {
      if (tabSelect.tabId == metricDetail.statmatrixmappingid) {
        showData.push(metricDetail);
      }
    });
    if (showData.length >= 5) {
      setShowAddModal(false);
      // messagePopup("", "You can't add more than 5 records ", "error")
      toastr.error("You can't add more than 5 records", '', {
        progressBar: true,
        timeOut: 2000,
        closeButton: true,
        positionClass: 'toast-top-full-width',
        showEasing: 'swing',
        fadeIn: 40000,
        preventDuplicates: true,
      });
    } else {
      setShowAddModal(true);
    }
  };
  const showAddVideoModalHandler = (e, metricData) => {
    if (metricData) {
      setMetricSelect(metricData);
    }
    setShowAddVideoModal(!showAddVideoModal);
  };
  const showDeleteVideoModalHandler = (e, metricData) => {
    if (metricData) {
      setMetricSelect(metricData);
    }
    setShowDeleteVideoModal(!showDeleteVideoModal);
  };
  const successMsg = () => {
    swal({
      text: 'Photo / Video Deleted Successfully.',
      icon: 'success',
    }).then((okay) => {
      if (okay || okay == null) {
        refreshAfterSave();
      }
    });
  };
  const onDeleteVideoHandler = async () => {
    const variables = {
      obj: {
        id: metricSelect.id,
        userid: getUserInfo().id,
        active: 1,
        videoname: null,
        videodescription: null,
        isvideoorlink: null,
      },
    };
    const finalDelObj = {
      deletedRank:
        metricSelect?.uploadedvideoandphotoStatidMap?.Uploadedvideoandphotos?.[
          metricSelect?.uploadedvideoandphotoStatidMap?.Uploadedvideoandphotos
            ?.length - 1
        ]?.uploadedrank ?? 0,
      photosVideosAndLinkId: metricSelect?.photovideoid ?? 0,
      photosVideosAndLinkType: '0',
      postId: 0,
      postarray: [],
      userId: getUserInfo()?.id ?? 0,
      visibleId: 0,
      isstats: 1,
    };
    props.statMetricDetailsSave({
      query: saveStatmatrixdetails,
      variables,
      successMsg: successMsg,
    });
    const deleteuploadPhotoVideo = {
      statid: metricSelect.id,
    };
    await fetchMethod(
      '/api/Statmatrixdetails/deleteStatPhotoVideo',
      deleteuploadPhotoVideo,
      'post',
      true
    );
    const deleteVidPhotoStatus = await fetchMethod(
      '/api/Uploadedvideoandphotos/removePhotosAndVideos',
      finalDelObj,
      'POST',
      true
    );
    if (deleteVidPhotoStatus?.status == 200) {
      // console.log("stats vid/photo msg", deleteVidPhotoStatus?.data?.response?.msg ?? "Error Ocurred")
    }
    fetchAllStatMetricDetails();
    showDeleteVideoModalHandler();
    setShowVideoReviewPopup(false);
  };

  useEffect(() => {
    props.athleteHeightWeightStart({
      query: getAthleteHeightWeight,
      variables: {
        obj: {
          userid: getUserInfo() ? getUserInfo().id : 0,
        },
      },
    });
    fetchMetricList();
    fetchAllStatMetricDetails();
  }, []);
  useEffect(() => {
    if (
      props.allMetricList &&
      props.allMetricList.data &&
      props.allMetricList.data.allMetrics
    ) {
      setMetricList([...props.allMetricList.data.allMetrics]);
    }
  }, [props.allMetricList]);
  useEffect(() => {
    if (
      props.allStatMetricDetailsList &&
      props.allStatMetricDetailsList.data &&
      props.allStatMetricDetailsList.data.allStatMetricsDetails
    ) {
      setStatMetricDetailsList([
        ...props.allStatMetricDetailsList.data.allStatMetricsDetails,
      ]);
    }
  }, [props.allStatMetricDetailsList]);

  const successSavedMsg = async () => {
    // let variables = {
    //   where: {
    //     userid: getUserInfo().id,
    //   },
    //   data: {
    //     verifiedby: "Not Verified",
    //     isscoutingrequestsent: 0,
    //     verified: 0,
    //     isscoutingrequestupdateOn :null
    //   },
    // };
    // const UpdatestatsRequestData = await fetchGraphMethod(updateScoutingRequestQuery, variables, true)
    swal({
      text: 'Metrics Saved Successfully.',
      icon: 'success',
    }).then((okay) => {
      if (okay || okay == null) {
        refreshAfterSave();
      }
    });
  };
  const onSaveHandler = (fields, isAddAnother) => {
    const variables = {
      obj: {
        id: fields.id ? fields.id : null,
        verified: 0,
        verifiedby: 'Not verified',
        isscoutingrequestsent: 0,
        isscoutingrequestupdateOn: null,
        isedit: 1,
        userid: getUserInfo().id,
        active: 1,
        heightinfeetid: fields.heightinfeet,
        heightininchecsid: fields.heightininches,
        weight: +fields.weight,
        testdate: fields.date,
        lasertime: fields.lasertime ? 1 : 0,
        result:
          tabSelect.tabData?.statsmatrixid == 3
            ? calculate1RM(fields.lbs, fields.reps)
            : tabSelect.tabData?.statsmatrixid == 2
            ? fields.jumpincentimeter == 0
              ? fields.jumpincentimeter.toString()
              : fields.jumpincentimeter.toString()
            : fields.result,
        reps: fields.reps ? fields.reps : null,
        lbs: fields.lbs ? fields.lbs : null,
        statmatrixmappingid: tabSelect.tabId,
        jumbidinfeet: fields.jumbidinfeet ? +fields.jumbidinfeet : null,
        jumbidininches: fields.jumbidininches ? +fields.jumbidininches : null,
        jumpincentimeter: fields.jumpincentimeter
          ? fields.jumpincentimeter
          : null,
      },
    };

    props.statMetricDetailsSave({
      query: saveStatmatrixdetails,
      variables,
      successSavedMsg: successSavedMsg,
    });
    let athleteHeightId = null;
    if (
      props.athleteHeightWeight &&
      props.athleteHeightWeight.data &&
      props.athleteHeightWeight.data.athleteHeightAndWeight &&
      props.athleteHeightWeight.data.athleteHeightAndWeight
        .allAthleteheightandweights &&
      props.athleteHeightWeight.data.athleteHeightAndWeight
        .allAthleteheightandweights.Athleteheightandweights &&
      props.athleteHeightWeight.data.athleteHeightAndWeight
        .allAthleteheightandweights.Athleteheightandweights[0]
    ) {
      athleteHeightId =
        props.athleteHeightWeight.data.athleteHeightAndWeight
          .allAthleteheightandweights.Athleteheightandweights[0].id;
    }
    if (
      props.athleteHeightWeight &&
      props.athleteHeightWeight.data &&
      props.athleteHeightWeight.data.saveAthleteHeightAndWeight &&
      props.athleteHeightWeight.data.saveAthleteHeightAndWeight
        .saveAthleteheightandweight &&
      props.athleteHeightWeight.data.saveAthleteHeightAndWeight
        .saveAthleteheightandweight.id
    ) {
      athleteHeightId =
        props.athleteHeightWeight.data.saveAthleteHeightAndWeight
          .saveAthleteheightandweight.id;
    }
    // props.athleteHeightWeightSaveStart({
    //   query: saveAthleteHeightWeight,
    //   variables: {
    //     obj: {
    //       id: athleteHeightId,
    //       userid: getUserInfo().id,
    //       heightinfeet: +fields.heightinfeet,
    //       heightininches: +fields.heightininches,
    //       weight: +fields.weight,
    //       weightinkilogram: +fields.weight * 0.45,
    //     },
    //   },
    // });
    // props.saveOnboardingStart({
    //   query: saveOnboardingVitalsDataQuery,
    //   variables: {
    //     obj: {
    //       userid: getUserInfo() ? getUserInfo().id : null,
    //       id: fields.onboardingId ? fields.onboardingId : null,
    //       heightinfeet: fields.heightinfeet,
    //       heightininches: fields.heightininches,
    //       weight: +fields.weight,
    //       updatedby: getUserInfo().id
    //     },
    //   },
    //   nextScreen: () => { }
    // });
    fetchAllStatMetricDetails();
    showAddModalHandler();
    sendStatsNotification();
  };
  const afterDeleteMetrics = async () => {
    swal({
      text: 'Metrics data deleted successfully.',
      icon: 'success',
    }).then((okay) => {
      if (okay || okay == null) {
        refreshAfterSave();
      }
    });
  };
  const onDeleteHandler = async (fields) => {
    const variables = {
      obj: {
        id: fields.id ? fields.id : null,
        userid: getUserInfo().id,
        active: 0,
      },
    };
    props.statMetricDetailsSave({
      query: saveStatmatrixdetails,
      variables,
      afterDeleteMetrics: afterDeleteMetrics,
    });
    const deleteuploadPhotoVideo = {
      statid: fields.id ? fields.id : null,
    };
    await fetchMethod(
      '/api/Statmatrixdetails/deleteStatPhotoVideo',
      deleteuploadPhotoVideo,
      'post',
      true
    );
    fetchAllStatMetricDetails();
    showAddModalHandler();
  };
  const showGraph = () => {
    const showData = [];
    statMetricDetailsList.map((metricDetail) => {
      if (tabSelect.tabId == metricDetail.statmatrixmappingid) {
        showData.push(metricDetail);
      }
    });
    const maxval =
      tabSelect.tabData != undefined
        ? tabSelect.tabData.statsmatrixid == 3
          ? +tabSelect.tabData.maximumvalue + 500
          : +tabSelect.tabData.maximumvalue
        : null;
    const maxVal = Math.floor(+maxval);
    return showData.length > 0 ? (
      showData.map((metricData) => {
        let percentage = null;
        if (tabSelect.id == 2) {
          const resultData = metricData.jumpincentimeter * 0.0328084;
          const ftValue =
            metricData?.statmatrixdetailsstatmatrixmappingidmaprel
              ?.Statmatrixmappings?.[0]?.tabname == 'Broad Jump'
              ? Math.round(resultData * 7.5)
              : Math.round(resultData * 17);
          percentage = parseFloat(ftValue);
          // percentage = Math.round((parseFloat(resultData) / maxVal) * 100);
        } else {
          percentage = Math.round(
            (parseFloat(metricData.result) / maxVal) * 100
          );
        }
        return (
          <div className="item" key={metricData.id}>
            <div
              className="progress-bar"
              style={{
                height: `${
                  percentage != ''
                    ? isNaN(percentage)
                      ? 0
                      : percentage <= 100
                      ? percentage == metricData.result
                        ? percentage + 1
                        : percentage
                      : 100
                    : parseInt(metricData.result) < 5
                    ? parseInt(metricData.result)
                    : percentage == 0
                    ? percentage + 1
                    : 100
                }%`,
                backgroundColor: '#1CB79E',
                background: 'opaque',
              }}
            >
              {metricData.verified == 1 ? (
                <div className="icon-box">
                  <span className="iconbox custom-tooltip">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14.449"
                      height="16.117"
                      viewBox="0 0 14.449 16.117"
                    >
                      <g transform="translate(-2.872 -1.125)">
                        <path
                          className="a"
                          d="M10.1,1.125a14.418,14.418,0,0,0-3.022.564q-1.5.4-2.978.876A1.563,1.563,0,0,0,3.018,3.837,13.013,13.013,0,0,0,5.562,13.9a12.025,12.025,0,0,0,2.6,2.471A7.481,7.481,0,0,0,9.241,17a2.232,2.232,0,0,0,.855.242A2.225,2.225,0,0,0,10.951,17a7.481,7.481,0,0,0,1.082-.63,12.024,12.024,0,0,0,2.6-2.471A13.017,13.017,0,0,0,17.175,3.837,1.563,1.563,0,0,0,16.1,2.565q-1.479-.473-2.978-.876A14.416,14.416,0,0,0,10.1,1.125Zm3.066,6.827a.538.538,0,0,0-.761-.761L9.559,10.035,8.327,8.8a.538.538,0,0,0-.761.761l1.612,1.612a.537.537,0,0,0,.761,0Z"
                          transform="translate(0)"
                        ></path>
                      </g>
                    </svg>
                    <span className="tooltip-data">Coach Verified</span>
                  </span>
                </div>
              ) : (
                ''
              )}
              {metricData.verified == 2 ? (
                <div className="icon-box">
                  <span className="iconbox red custom-tooltip">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14.449"
                      height="16.117"
                      viewBox="0 0 14.449 16.117"
                    >
                      <g transform="translate(-2.872 -1.125)">
                        <path
                          className="a"
                          d="M10.1,1.125a14.418,14.418,0,0,0-3.022.564q-1.5.4-2.978.876A1.563,1.563,0,0,0,3.018,3.837,13.013,13.013,0,0,0,5.562,13.9a12.025,12.025,0,0,0,2.6,2.471A7.481,7.481,0,0,0,9.241,17a2.232,2.232,0,0,0,.855.242A2.225,2.225,0,0,0,10.951,17a7.481,7.481,0,0,0,1.082-.63,12.024,12.024,0,0,0,2.6-2.471A13.017,13.017,0,0,0,17.175,3.837,1.563,1.563,0,0,0,16.1,2.565q-1.479-.473-2.978-.876A14.416,14.416,0,0,0,10.1,1.125Zm3.066,6.827a.538.538,0,0,0-.761-.761L9.559,10.035,8.327,8.8a.538.538,0,0,0-.761.761l1.612,1.612a.537.537,0,0,0,.761,0Z"
                          transform="translate(0)"
                        ></path>
                      </g>
                    </svg>
                    <span className="tooltip-data">SportsForce Verified</span>
                  </span>
                </div>
              ) : (
                ''
              )}
              {metricData.verified == 3 ? (
                <div className="icon-box">
                  <span className="iconbox custom-tooltip">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14.449"
                      height="16.117"
                      viewBox="0 0 14.449 16.117"
                    >
                      <g transform="translate(-2.872 -1.125)">
                        <path
                          className="a"
                          d="M10.1,1.125a14.418,14.418,0,0,0-3.022.564q-1.5.4-2.978.876A1.563,1.563,0,0,0,3.018,3.837,13.013,13.013,0,0,0,5.562,13.9a12.025,12.025,0,0,0,2.6,2.471A7.481,7.481,0,0,0,9.241,17a2.232,2.232,0,0,0,.855.242A2.225,2.225,0,0,0,10.951,17a7.481,7.481,0,0,0,1.082-.63,12.024,12.024,0,0,0,2.6-2.471A13.017,13.017,0,0,0,17.175,3.837,1.563,1.563,0,0,0,16.1,2.565q-1.479-.473-2.978-.876A14.416,14.416,0,0,0,10.1,1.125Zm3.066,6.827a.538.538,0,0,0-.761-.761L9.559,10.035,8.327,8.8a.538.538,0,0,0-.761.761l1.612,1.612a.537.537,0,0,0,.761,0Z"
                          transform="translate(0)"
                        ></path>
                      </g>
                    </svg>
                    <span className="tooltip-data">Coach Verified</span>
                  </span>
                  <span className="iconbox red custom-tooltip">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14.449"
                      height="16.117"
                      viewBox="0 0 14.449 16.117"
                    >
                      <g transform="translate(-2.872 -1.125)">
                        <path
                          className="a"
                          d="M10.1,1.125a14.418,14.418,0,0,0-3.022.564q-1.5.4-2.978.876A1.563,1.563,0,0,0,3.018,3.837,13.013,13.013,0,0,0,5.562,13.9a12.025,12.025,0,0,0,2.6,2.471A7.481,7.481,0,0,0,9.241,17a2.232,2.232,0,0,0,.855.242A2.225,2.225,0,0,0,10.951,17a7.481,7.481,0,0,0,1.082-.63,12.024,12.024,0,0,0,2.6-2.471A13.017,13.017,0,0,0,17.175,3.837,1.563,1.563,0,0,0,16.1,2.565q-1.479-.473-2.978-.876A14.416,14.416,0,0,0,10.1,1.125Zm3.066,6.827a.538.538,0,0,0-.761-.761L9.559,10.035,8.327,8.8a.538.538,0,0,0-.761.761l1.612,1.612a.537.537,0,0,0,.761,0Z"
                          transform="translate(0)"
                        ></path>
                      </g>
                    </svg>
                    <span className="tooltip-data">SportsForce Verified</span>
                  </span>
                </div>
              ) : (
                ''
              )}
            </div>
          </div>
        );
      })
    ) : (
      <div className="item">
        <div className="progress-bar no-data">
          <button
            className="btn green custom-tooltip"
            onClick={addDataFirstTime}
            disabled={tabSelect.tabId && tabSelect.tabId != 0 ? false : true}
          >
            <span className="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="17"
                viewBox="0 0 17 17"
              >
                <g transform="translate(1.553 1.553)">
                  <line
                    className="a"
                    x2="14"
                    transform="translate(-0.053 6.947)"
                  />
                  <line
                    className="a"
                    y2="14"
                    transform="translate(6.947 -0.053)"
                  />
                </g>
              </svg>
            </span>
            {/*below span is commented as per task jira 229*/}
            {/*<span>Add Data</span>*/}
            {tabSelect.tabId && tabSelect.tabId != 0 ? (
              ''
            ) : (
              <span className="tooltip-data">
                Select metric from
                <br /> dropdown right
                <br /> above.
              </span>
            )}
          </button>
        </div>
      </div>
    );
  };
  const reviewVideo = (e, metricData) => {
    e.preventDefault();
    setShowVideoReviewPopup(true);
    setMetricSelect(metricData);
  };
  const wenLinkStatus = (data) => {
    setWebLinkState(!!data?.weblink ? data?.weblink : '');
    setMatData(data);
    setOpenLinkPop(true);
  };
  //func for saving the weblink
  const onClickDone = async (value) => {
    const valValue =
      value == 'del'
        ? true
        : webLinkState?.includes('http') ||
          webLinkState?.includes('https') ||
          webLinkState?.includes('www.');
    if (valValue) {
      setIsValid(false);
      const variables = {
        obj: {
          userid: getUserInfo().id,
          active: 1,
          id: matData.id,
          weblink: value == 'del' ? '' : webLinkState,
          verified: 0,
          verifiedby: 'Not verified',
          isscoutingrequestsent: 0,
          isscoutingrequestupdateOn: null,
          isedit: 1,
          verifiedbrandlogo: null,
        },
      };
      const _resMat = await fetchGraphMethod(
        saveStatmatrixdetails,
        variables,
        true
      );
      if (_resMat?.status == 200) {
        setOpenLinkPop(false);
        setIsDelPop(false);
        //for refreshing the state
        setTimeout(() => {
          window?.location?.reload();
        }, 500);
      } else {
        swal({ text: 'Failed', icon: 'error' });
      }
    } else {
      setIsValid(true);
    }
  };
  const showGraphLabel = () => {
    const showData = [];
    statMetricDetailsList.forEach((metricDetail) => {
      if (tabSelect.tabId == metricDetail.statmatrixmappingid) {
        showData.push(metricDetail);
      }
    });

    return showData.length > 0 ? (
      showData.map((metricData) => {
        const heightinFeet = metricData.statmatrixdetailsheightinfeetidmaprel
          ? metricData.statmatrixdetailsheightinfeetidmaprel.Heightinfeets
            ? metricData.statmatrixdetailsheightinfeetidmaprel.Heightinfeets[0]
              ? metricData.statmatrixdetailsheightinfeetidmaprel
                  .Heightinfeets[0].heightvalue
              : ''
            : ''
          : '';
        const heightinInch = metricData.statmatrixdetailsheightininchecsidmaprel
          ? metricData.statmatrixdetailsheightininchecsidmaprel.Heightininches
            ? metricData.statmatrixdetailsheightininchecsidmaprel
                .Heightininches[0]
              ? metricData.statmatrixdetailsheightininchecsidmaprel
                  .Heightininches[0].inchvalue
              : ''
            : ''
          : '';
        return (
          <div className="item" key={metricData.id}>
            <div className="detial-box">
              <h4>
                {heightinFeet}' {heightinInch}" / {metricData.weight} lbs
              </h4>
              <h5>
                {getMetricLabel(tabSelect, isEdit, handeIsEdit, metricData)}
              </h5>
              {metricData.verified !== 0 ? (
                <p>
                  VERIFIED <br />
                  {!!metricData?.testdate
                    ? getUTCTimeDateOverall(metricData?.testdate ?? '')
                    : ''}
                </p>
              ) : (
                <p>
                  UNVERIFIED <br />
                  {!!metricData?.testdate
                    ? getUTCTimeDateOverall(metricData?.testdate ?? '')
                    : ''}
                </p>
              )}
              <div className="button-box">
                {metricData.videoname ? (
                  <>
                    <button
                      className="edit-btn"
                      onClick={() => {
                        handeIsEdit(metricData);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16.993"
                        height="16.993"
                        viewBox="0 0 16.993 16.993"
                      >
                        <path
                          id="pencil"
                          d="M16.557,2.751,14.326.511A1.641,1.641,0,0,0,12,.606a1.659,1.659,0,0,0-.094,2.334l2.231,2.24a1.643,1.643,0,0,0,2.324-.094,1.659,1.659,0,0,0,.092-2.334ZM2.336,10.31,6.8,14.79l7.25-7.278L9.586,3.032,2.336,10.31ZM0,17.067l5.884-1.183L1.178,11.159Z"
                          transform="translate(0 -0.074)"
                          fill="#1cb79e"
                        />
                      </svg>
                    </button>
                    <button
                      className="video-btn trash"
                      data-toggle="modal"
                      data-target="#StatsVideoTrashModal"
                    >
                      {/* <svg onClick={(e) => reviewVideo(e, metricData)} xmlns="http://www.w3.org/2000/svg" width="28.738" height="30.943" viewBox="0 0 28.738 22.943"><g transform="translate(-831 -1070.057)"><path className="a" d="M12.61,23.565a1.266,1.266,0,0,0,.677.2,1.222,1.222,0,0,0,.5-.109L20.9,20.488a1.23,1.23,0,0,0,0-2.255L13.789,15.06a1.237,1.237,0,0,0-1.739,1.128v6.344a1.237,1.237,0,0,0,.56,1.033Zm.458-7.377a.211.211,0,0,1,.1-.182.218.218,0,0,1,.116,0,.2.2,0,0,1,.087,0l7.108,3.165a.211.211,0,0,1,.131.2.2.2,0,0,1-.131.2l-7.108,3.172a.2.2,0,0,1-.2,0,.226.226,0,0,1-.1-.182Z" transform="translate(826.275 1059.873)"></path><path className="b" d="M25.991,10.122A2.759,2.759,0,0,0,23.117,7.5H5.874A2.759,2.759,0,0,0,3,10.122V23.233a2.759,2.759,0,0,0,2.874,2.622H23.117a2.759,2.759,0,0,0,2.874-2.622v-4.37l5.748,4.37V10.122l-5.748,4.37ZM24.078,24.107H4.916V9.248H24.075l0,7.428,0,0,0,0,0,7.428Z" transform="translate(828 1062.557)"></path></g></svg> */}
                      <svg
                        onClick={(e) => reviewVideo(e, metricData)}
                        id="Group_1127"
                        data-name="Group 1127"
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                      >
                        <g id="Group_1126" data-name="Group 1126">
                          <path
                            id="Path_2126"
                            data-name="Path 2126"
                            d="M16.313,0H1.688A1.688,1.688,0,0,0,0,1.688V16.313A1.688,1.688,0,0,0,1.688,18H16.313A1.688,1.688,0,0,0,18,16.313V1.688A1.688,1.688,0,0,0,16.313,0Zm.563,11.019L14.462,8.606a.562.562,0,0,0-.793,0l-2.981,2.975L7.149,8.044a.562.562,0,0,0-.793,0L1.125,13.269V1.688a.563.563,0,0,1,.563-.562H16.313a.563.563,0,0,1,.563.563Z"
                            fill="#c0321f"
                          />
                          <path
                            id="Path_2127"
                            data-name="Path 2127"
                            d="M226.373,80a2.373,2.373,0,1,0,2.373,2.373A2.373,2.373,0,0,0,226.373,80Zm0,3.56a1.187,1.187,0,1,1,1.187-1.187,1.187,1.187,0,0,1-1.187,1.187Z"
                            transform="translate(-216.269 -77.239)"
                            fill="#c0321f"
                          />
                        </g>
                      </svg>
                      {/*Code is commented as per task 653*/}
                      {/*<span*/}
                      {/*  className="videoclose-btn"*/}
                      {/*  onClick={(e) => {*/}
                      {/*    showDeleteVideoModalHandler(e, metricData);*/}
                      {/*  }}*/}
                      {/*>x</span>*/}
                    </button>
                    <button
                      className={!!metricData ? 'link-btn red' : 'link-btn'}
                      style={{
                        cursor: !!metricData ? 'pointer' : 'not-allowed',
                      }}
                      disabled={!!metricData ? false : true}
                      onClick={(e) => wenLinkStatus(metricData)}
                    >
                      <svg
                        id="link"
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16.002"
                        viewBox="0 0 16 16.002"
                      >
                        <g
                          id="Group_2319"
                          data-name="Group 2319"
                          transform="translate(0 5.064)"
                        >
                          <g
                            id="Group_2318"
                            data-name="Group 2318"
                            transform="translate(0)"
                          >
                            {!!metricData?.weblink ? (
                              <>
                                <path
                                  fill={'#00B9FF'}
                                  id="Path_2307"
                                  data-name="Path 2307"
                                  d="M9.873,165.715a3.655,3.655,0,0,0-.631-.508,3.761,3.761,0,0,0-4.687.508l-3.417,3.419a3.761,3.761,0,0,0,5.316,5.321l2.82-2.82a.269.269,0,0,0-.191-.459H8.976a4.522,4.522,0,0,1-1.719-.333.269.269,0,0,0-.293.059l-2.028,2.031a1.613,1.613,0,1,1-2.281-2.281l3.43-3.428a1.612,1.612,0,0,1,2.278,0,1.1,1.1,0,0,0,1.51,0,1.064,1.064,0,0,0,0-1.51Z"
                                  transform="translate(-0.039 -164.614)"
                                />
                                <path
                                  fill={'#00B9FF'}
                                  id="Path_2307"
                                  data-name="Path 2307"
                                  d="M9.873,165.715a3.655,3.655,0,0,0-.631-.508,3.761,3.761,0,0,0-4.687.508l-3.417,3.419a3.761,3.761,0,0,0,5.316,5.321l2.82-2.82a.269.269,0,0,0-.191-.459H8.976a4.522,4.522,0,0,1-1.719-.333.269.269,0,0,0-.293.059l-2.028,2.031a1.613,1.613,0,1,1-2.281-2.281l3.43-3.428a1.612,1.612,0,0,1,2.278,0,1.1,1.1,0,0,0,1.51,0,1.064,1.064,0,0,0,0-1.51Z"
                                  transform="translate(-0.039 -164.614)"
                                />
                              </>
                            ) : (
                              <>
                                <path
                                  fill={'#3e3e3e'}
                                  id="Path_2307"
                                  data-name="Path 2307"
                                  d="M9.873,165.715a3.655,3.655,0,0,0-.631-.508,3.761,3.761,0,0,0-4.687.508l-3.417,3.419a3.761,3.761,0,0,0,5.316,5.321l2.82-2.82a.269.269,0,0,0-.191-.459H8.976a4.522,4.522,0,0,1-1.719-.333.269.269,0,0,0-.293.059l-2.028,2.031a1.613,1.613,0,1,1-2.281-2.281l3.43-3.428a1.612,1.612,0,0,1,2.278,0,1.1,1.1,0,0,0,1.51,0,1.064,1.064,0,0,0,0-1.51Z"
                                  transform="translate(-0.039 -164.614)"
                                />
                                <path
                                  fill={'#3e3e3e'}
                                  id="Path_2307"
                                  data-name="Path 2307"
                                  d="M9.873,165.715a3.655,3.655,0,0,0-.631-.508,3.761,3.761,0,0,0-4.687.508l-3.417,3.419a3.761,3.761,0,0,0,5.316,5.321l2.82-2.82a.269.269,0,0,0-.191-.459H8.976a4.522,4.522,0,0,1-1.719-.333.269.269,0,0,0-.293.059l-2.028,2.031a1.613,1.613,0,1,1-2.281-2.281l3.43-3.428a1.612,1.612,0,0,1,2.278,0,1.1,1.1,0,0,0,1.51,0,1.064,1.064,0,0,0,0-1.51Z"
                                  transform="translate(-0.039 -164.614)"
                                />
                              </>
                            )}
                          </g>
                        </g>
                        <g
                          id="Group_2321"
                          data-name="Group 2321"
                          transform="translate(5.847)"
                        >
                          <g
                            id="Group_2320"
                            data-name="Group 2320"
                            transform="translate(0 0)"
                          >
                            {!!metricData?.weblink ? (
                              <path
                                fill={'#00B9FF'}
                                id="Path_2308"
                                data-name="Path 2308"
                                d="M198.554,1.1a3.761,3.761,0,0,0-5.319,0l-2.818,2.815a.27.27,0,0,0,.2.459h.1a4.513,4.513,0,0,1,1.716.336.269.269,0,0,0,.293-.059l2.023-2.02a1.613,1.613,0,0,1,2.281,2.281l-2.52,2.517-.022.024-.881.876a1.612,1.612,0,0,1-2.278,0,1.1,1.1,0,0,0-1.51,0,1.071,1.071,0,0,0,0,1.515,3.728,3.728,0,0,0,1.074.752c.056.027.113.048.169.073s.115.043.172.064.115.04.172.056l.159.043c.107.027.215.048.325.067a3.739,3.739,0,0,0,.4.038h.2l.161-.019c.059,0,.121-.016.191-.016h.091l.185-.027.086-.016.156-.032h.03a3.76,3.76,0,0,0,1.743-.989l3.42-3.42A3.761,3.761,0,0,0,198.554,1.1Z"
                                transform="translate(-189.502 0)"
                              />
                            ) : (
                              <path
                                fill={'#3e3e3e'}
                                id="Path_2308"
                                data-name="Path 2308"
                                d="M198.554,1.1a3.761,3.761,0,0,0-5.319,0l-2.818,2.815a.27.27,0,0,0,.2.459h.1a4.513,4.513,0,0,1,1.716.336.269.269,0,0,0,.293-.059l2.023-2.02a1.613,1.613,0,0,1,2.281,2.281l-2.52,2.517-.022.024-.881.876a1.612,1.612,0,0,1-2.278,0,1.1,1.1,0,0,0-1.51,0,1.071,1.071,0,0,0,0,1.515,3.728,3.728,0,0,0,1.074.752c.056.027.113.048.169.073s.115.043.172.064.115.04.172.056l.159.043c.107.027.215.048.325.067a3.739,3.739,0,0,0,.4.038h.2l.161-.019c.059,0,.121-.016.191-.016h.091l.185-.027.086-.016.156-.032h.03a3.76,3.76,0,0,0,1.743-.989l3.42-3.42A3.761,3.761,0,0,0,198.554,1.1Z"
                                transform="translate(-189.502 0)"
                              />
                            )}
                          </g>
                        </g>
                      </svg>
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      className="edit-btn"
                      onClick={() => {
                        handeIsEdit(metricData);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16.993"
                        height="16.993"
                        viewBox="0 0 16.993 16.993"
                      >
                        <path
                          id="pencil"
                          d="M16.557,2.751,14.326.511A1.641,1.641,0,0,0,12,.606a1.659,1.659,0,0,0-.094,2.334l2.231,2.24a1.643,1.643,0,0,0,2.324-.094,1.659,1.659,0,0,0,.092-2.334ZM2.336,10.31,6.8,14.79l7.25-7.278L9.586,3.032,2.336,10.31ZM0,17.067l5.884-1.183L1.178,11.159Z"
                          transform="translate(0 -0.074)"
                          fill="#1cb79e"
                        />
                      </svg>
                    </button>
                    <button
                      className="video-btn"
                      onClick={(e) => {
                        showAddVideoModalHandler(e, metricData);
                      }}
                    >
                      <svg
                        id="Group_1127"
                        data-name="Group 1127"
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                      >
                        <g id="Group_1126" data-name="Group 1126">
                          <path
                            id="Path_2126"
                            data-name="Path 2126"
                            d="M16.313,0H1.688A1.688,1.688,0,0,0,0,1.688V16.313A1.688,1.688,0,0,0,1.688,18H16.313A1.688,1.688,0,0,0,18,16.313V1.688A1.688,1.688,0,0,0,16.313,0Zm.563,11.019L14.462,8.606a.562.562,0,0,0-.793,0l-2.981,2.975L7.149,8.044a.562.562,0,0,0-.793,0L1.125,13.269V1.688a.563.563,0,0,1,.563-.562H16.313a.563.563,0,0,1,.563.563Z"
                            fill="#3e3e3e"
                          />
                          <path
                            id="Path_2127"
                            data-name="Path 2127"
                            d="M226.373,80a2.373,2.373,0,1,0,2.373,2.373A2.373,2.373,0,0,0,226.373,80Zm0,3.56a1.187,1.187,0,1,1,1.187-1.187,1.187,1.187,0,0,1-1.187,1.187Z"
                            transform="translate(-216.269 -77.239)"
                            fill="#3e3e3e"
                          />
                        </g>
                      </svg>
                      {/* <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="26.262"
                        height="16.773"
                        viewBox="0 0 26.262 16.773"
                      >
                        <g transform="translate(-846 -1139.805)">
                          <path
                            className="a"
                            d="M24.009,9.9a2.521,2.521,0,0,0-2.626-2.4H5.626A2.521,2.521,0,0,0,3,9.9V21.877a2.521,2.521,0,0,0,2.626,2.4H21.383a2.521,2.521,0,0,0,2.626-2.4V17.883l5.252,3.994V9.9L24.009,13.89ZM22.261,22.676H4.751V9.1H22.259l0,6.787,0,0,0,0,0,6.787Z"
                            transform="translate(843 1132.305)"
                          ></path>
                          <path
                            className="a"
                            d="M12.688,8.207h-3v-3a.742.742,0,0,0-1.483,0v3h-3a.742.742,0,0,0,0,1.483h3v3a.742.742,0,0,0,1.483,0v-3h3a.742.742,0,0,0,0-1.483Z"
                            transform="translate(847.118 1139.243)"
                          ></path>
                        </g>
                      </svg> */}
                    </button>
                    <button
                      className={!!metricData ? 'link-btn red' : 'link-btn'}
                      style={{
                        cursor: !!metricData ? 'pointer' : 'not-allowed',
                      }}
                      disabled={!!metricData ? false : true}
                      onClick={(e) => wenLinkStatus(metricData)}
                    >
                      <svg
                        id="link"
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16.002"
                        viewBox="0 0 16 16.002"
                      >
                        <g
                          id="Group_2319"
                          data-name="Group 2319"
                          transform="translate(0 5.064)"
                        >
                          <g
                            id="Group_2318"
                            data-name="Group 2318"
                            transform="translate(0)"
                          >
                            {!!metricData?.weblink ? (
                              <>
                                <path
                                  fill={'#00B9FF'}
                                  id="Path_2307"
                                  data-name="Path 2307"
                                  d="M9.873,165.715a3.655,3.655,0,0,0-.631-.508,3.761,3.761,0,0,0-4.687.508l-3.417,3.419a3.761,3.761,0,0,0,5.316,5.321l2.82-2.82a.269.269,0,0,0-.191-.459H8.976a4.522,4.522,0,0,1-1.719-.333.269.269,0,0,0-.293.059l-2.028,2.031a1.613,1.613,0,1,1-2.281-2.281l3.43-3.428a1.612,1.612,0,0,1,2.278,0,1.1,1.1,0,0,0,1.51,0,1.064,1.064,0,0,0,0-1.51Z"
                                  transform="translate(-0.039 -164.614)"
                                />
                                <path
                                  fill={'#00B9FF'}
                                  id="Path_2307"
                                  data-name="Path 2307"
                                  d="M9.873,165.715a3.655,3.655,0,0,0-.631-.508,3.761,3.761,0,0,0-4.687.508l-3.417,3.419a3.761,3.761,0,0,0,5.316,5.321l2.82-2.82a.269.269,0,0,0-.191-.459H8.976a4.522,4.522,0,0,1-1.719-.333.269.269,0,0,0-.293.059l-2.028,2.031a1.613,1.613,0,1,1-2.281-2.281l3.43-3.428a1.612,1.612,0,0,1,2.278,0,1.1,1.1,0,0,0,1.51,0,1.064,1.064,0,0,0,0-1.51Z"
                                  transform="translate(-0.039 -164.614)"
                                />
                              </>
                            ) : (
                              <>
                                <path
                                  fill={'#3e3e3e'}
                                  id="Path_2307"
                                  data-name="Path 2307"
                                  d="M9.873,165.715a3.655,3.655,0,0,0-.631-.508,3.761,3.761,0,0,0-4.687.508l-3.417,3.419a3.761,3.761,0,0,0,5.316,5.321l2.82-2.82a.269.269,0,0,0-.191-.459H8.976a4.522,4.522,0,0,1-1.719-.333.269.269,0,0,0-.293.059l-2.028,2.031a1.613,1.613,0,1,1-2.281-2.281l3.43-3.428a1.612,1.612,0,0,1,2.278,0,1.1,1.1,0,0,0,1.51,0,1.064,1.064,0,0,0,0-1.51Z"
                                  transform="translate(-0.039 -164.614)"
                                />
                                <path
                                  fill={'#3e3e3e'}
                                  id="Path_2307"
                                  data-name="Path 2307"
                                  d="M9.873,165.715a3.655,3.655,0,0,0-.631-.508,3.761,3.761,0,0,0-4.687.508l-3.417,3.419a3.761,3.761,0,0,0,5.316,5.321l2.82-2.82a.269.269,0,0,0-.191-.459H8.976a4.522,4.522,0,0,1-1.719-.333.269.269,0,0,0-.293.059l-2.028,2.031a1.613,1.613,0,1,1-2.281-2.281l3.43-3.428a1.612,1.612,0,0,1,2.278,0,1.1,1.1,0,0,0,1.51,0,1.064,1.064,0,0,0,0-1.51Z"
                                  transform="translate(-0.039 -164.614)"
                                />
                              </>
                            )}
                          </g>
                        </g>
                        <g
                          id="Group_2321"
                          data-name="Group 2321"
                          transform="translate(5.847)"
                        >
                          <g
                            id="Group_2320"
                            data-name="Group 2320"
                            transform="translate(0 0)"
                          >
                            {!!metricData?.weblink ? (
                              <path
                                fill={'#00B9FF'}
                                id="Path_2308"
                                data-name="Path 2308"
                                d="M198.554,1.1a3.761,3.761,0,0,0-5.319,0l-2.818,2.815a.27.27,0,0,0,.2.459h.1a4.513,4.513,0,0,1,1.716.336.269.269,0,0,0,.293-.059l2.023-2.02a1.613,1.613,0,0,1,2.281,2.281l-2.52,2.517-.022.024-.881.876a1.612,1.612,0,0,1-2.278,0,1.1,1.1,0,0,0-1.51,0,1.071,1.071,0,0,0,0,1.515,3.728,3.728,0,0,0,1.074.752c.056.027.113.048.169.073s.115.043.172.064.115.04.172.056l.159.043c.107.027.215.048.325.067a3.739,3.739,0,0,0,.4.038h.2l.161-.019c.059,0,.121-.016.191-.016h.091l.185-.027.086-.016.156-.032h.03a3.76,3.76,0,0,0,1.743-.989l3.42-3.42A3.761,3.761,0,0,0,198.554,1.1Z"
                                transform="translate(-189.502 0)"
                              />
                            ) : (
                              <path
                                fill={'#3e3e3e'}
                                id="Path_2308"
                                data-name="Path 2308"
                                d="M198.554,1.1a3.761,3.761,0,0,0-5.319,0l-2.818,2.815a.27.27,0,0,0,.2.459h.1a4.513,4.513,0,0,1,1.716.336.269.269,0,0,0,.293-.059l2.023-2.02a1.613,1.613,0,0,1,2.281,2.281l-2.52,2.517-.022.024-.881.876a1.612,1.612,0,0,1-2.278,0,1.1,1.1,0,0,0-1.51,0,1.071,1.071,0,0,0,0,1.515,3.728,3.728,0,0,0,1.074.752c.056.027.113.048.169.073s.115.043.172.064.115.04.172.056l.159.043c.107.027.215.048.325.067a3.739,3.739,0,0,0,.4.038h.2l.161-.019c.059,0,.121-.016.191-.016h.091l.185-.027.086-.016.156-.032h.03a3.76,3.76,0,0,0,1.743-.989l3.42-3.42A3.761,3.761,0,0,0,198.554,1.1Z"
                                transform="translate(-189.502 0)"
                              />
                            )}
                          </g>
                        </g>
                      </svg>
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        );
      })
    ) : (
      <div className="item">
        <div className="detial-box">
          <p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16.375"
              height="14.153"
              viewBox="0 0 16.375 14.153"
            >
              <path
                d="M17.567,13.648,11.854,4.175a2.555,2.555,0,0,0-4.3,0L1.837,13.648A2.234,2.234,0,0,0,1.8,15.882a2.51,2.51,0,0,0,2.19,1.266H15.414a2.51,2.51,0,0,0,2.19-1.236A2.234,2.234,0,0,0,17.567,13.648ZM9.7,14.169a.745.745,0,1,1,.745-.745A.745.745,0,0,1,9.7,14.169Zm.745-2.979a.745.745,0,1,1-1.49,0V8.211a.745.745,0,1,1,1.49,0Z"
                transform="translate(-1.519 -2.996)"
              ></path>
            </svg>{' '}
            No Test Data Available
          </p>
        </div>
      </div>
    );
  };

  const fetchMetricList = () => {
    props.allMetricListStart({
      query: fetchAllMetricsWithDetailsQuery({
        userid: getUserInfo ? getUserInfo().id : 0,
      }),
    });
  };
  const refreshAfterSave = () => {
    window.location.reload();
  };
  const fetchAllStatMetricDetails = () => {
    props.allStatMetricDetailsStart({
      query: fetchAllStatMetricsDetailsQuery,
      variables: {
        where: {
          active: 1,
          userid: getUserInfo().id,
        },
      },
    });
  };
  const onChangeHandler = (e, field, metric, tabid) => {
    if (field == 'tabname') {
      let tabData;
      const obj = {
        id: metric.id,
        tabId: e.target.value ? e.target.value : '',
      };
      if (tabid) {
        obj.tabId = tabid;
      }
      metric.statmatrixmappingStatsmatrixIdMap.Statmatrixmappings.map((tab) => {
        if (obj.tabId == tab.id) {
          tabData = tab;
        }
      });
      setisEdit(false);
      setTabSelect({ ...obj, tabData });
    }
  };
  const onClickUpdatePopReview = () => {
    setisEdit(false);
    setShowVideoReviewPopup(false);
    setShowAddVideoModal(true);
  };
  const onClickDeleteVidPhoto = () => {
    setShowDeleteVideoModal(true);
  };
  const getSelectedTabYAxis = () => {
    let maxVal =
      tabSelect.tabData != undefined
        ? tabSelect.tabData.statsmatrixid == 3
          ? +tabSelect.tabData.maximumvalue + 500
          : +tabSelect.tabData.maximumvalue
        : null;
    let minVal = +tabSelect?.tabData?.minimumvalue;
    const yAxis = [];
    if ((!minVal && isNaN(minVal)) || (!maxVal && isNaN(maxVal))) {
      minVal = 10;
      maxVal = 100;
    }
    if (parseFloat(maxVal) < 10) {
      if (tabSelect?.tabData?.statsmatrixid == 2) {
        for (let i = maxVal; i > minVal; i--) {
          yAxis.push(i + "'" + ' ' + '0' + `"`);
        }
      } else {
        for (let i = maxVal; i >= minVal; i--) {
          yAxis.push(parseInt(i));
        }
      }
    } else {
      if (tabSelect?.tabData?.statsmatrixid == 2) {
        for (let i = maxVal; i > minVal; i -= 2) {
          yAxis.push(i + "'" + ' ' + '0' + `"`);
        }
      } else if (parseFloat(maxVal) % 2) {
        for (let i = maxVal; i >= minVal; i -= maxVal / 10) {
          yAxis.push(parseInt(i));
        }
      } else {
        for (let i = maxVal; i >= minVal; i -= maxVal / 10) {
          yAxis.push(parseInt(i));
        }
        // this loop was adding +1 in the last item
        // for (let i = (maxVal+1); i >= minVal; i -= (maxVal + 1)/ 10) {
        //   yAxis.push(parseInt(i));
        // }
      }
    }
    return yAxis.map((value, index) => (
      <li className="item" key={index}>
        <span>{value}</span>
      </li>
    ));
  };
  const showCheckMark = () => {
    const showData = [];
    statMetricDetailsList.map((metricDetail) => {
      if (tabSelect.tabId == metricDetail.statmatrixmappingid) {
        showData.push(metricDetail);
      }
    });
    return showData[0] ? true : false;
  };
  const getMetricsList = () => {
    return metricList.map((metric) => {
      return (
        <div className="toggle-block" key={metric.id}>
          <div
            // className={
            //   (toggleValueArray.includes(metric.id) == false)
            //     ? "toggle-title"
            //     : "toggle-title toggle-open"
            // }
            className={
              toggleId == metric.id
                ? 'toggle-title toggle-open'
                : 'toggle-title'
            }
            onClick={() => {
              handleToggleId(metric.id);
            }}
          >
            {metric.matrixname}
          </div>
          <div
            className="toggle-content"
            //style={{ display: (toggleValueArray.includes(metric.id) == false) ? "none" : "block" }}
            style={{ display: toggleId == metric.id ? 'block' : 'none' }}
          >
            <div className="stats-filter-box">
              <div className="item">
                {/* <div className="icon-box">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    style={{ fill: "#3e3e3e", fillRule: "evenodd" }}
                  >
                    <path
                      className="a"
                      d="M13.5,7.875a.625.625,0,0,1,.625.625v5a.625.625,0,0,1-.625.625h-5a.625.625,0,0,1,0-1.25h4.375V8.5A.625.625,0,0,1,13.5,7.875Z"
                      transform="translate(-3.5 -3.5)"
                    />
                    <path
                      className="a"
                      d="M16.875,17.5a.625.625,0,0,1,.625-.625h5a.625.625,0,0,1,0,1.25H18.125V22.5a.625.625,0,0,1-1.25,0Z"
                      transform="translate(-7.5 -7.5)"
                    />
                    <path
                      className="a"
                      d="M10,18.75A8.75,8.75,0,1,0,1.25,10,8.75,8.75,0,0,0,10,18.75ZM10,20A10,10,0,1,0,0,10,10,10,0,0,0,10,20Z"
                    />
                  </svg>
                </div>
                <div className="content-box">
                  <h4>Add New Metric</h4>
                </div> */}
              </div>
              <div className="item">
                <Select
                  value={tabSelect.id === metric.id ? tabSelect.tabId : '0'}
                  onChange={(e) => {
                    onChangeHandler(e, 'tabname', metric);
                  }}
                  defaultValue={0}
                >
                  <MenuItem key="0" value="0">
                    Select Metric
                  </MenuItem>
                  {metric.statmatrixmappingStatsmatrixIdMap &&
                  metric.statmatrixmappingStatsmatrixIdMap.Statmatrixmappings
                    ? metric.statmatrixmappingStatsmatrixIdMap.Statmatrixmappings.map(
                        (item, index) => {
                          return (
                            <MenuItem selected key={item.id} value={item.id}>
                              {item.tabname}
                            </MenuItem>
                          );
                        }
                      )
                    : ''}
                </Select>
              </div>
            </div>
            <div
              className={
                tabSelect.id === metric.id &&
                tabSelect?.tabData?.statmatrixdetailsstatMatrixmappingidMap
                  ?.totalCount > 2
                  ? 'stats-graph-box state-show-scroller'
                  : 'stats-graph-box state-hide-scroller'
              }
            >
              <div className="graph-inner">
                <ul className="graph">{getSelectedTabYAxis()}</ul>
                <div className="graph-flex-bar">
                  {tabSelect.id === metric.id ? (
                    showGraph()
                  ) : (
                    <div className="item">
                      <div className="progress-bar no-data">
                        <button
                          className="btn green custom-tooltip"
                          onClick={showAddModalHandler}
                          disabled={
                            tabSelect.id === metric.id &&
                            tabSelect.tabId &&
                            tabSelect.tabId != 0
                              ? false
                              : true
                          }
                        >
                          <span className="icon">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="17"
                              height="17"
                              viewBox="0 0 17 17"
                            >
                              <g transform="translate(1.553 1.553)">
                                <line
                                  className="a"
                                  x2="14"
                                  transform="translate(-0.053 6.947)"
                                />
                                <line
                                  className="a"
                                  y2="14"
                                  transform="translate(6.947 -0.053)"
                                />
                              </g>
                            </svg>
                          </span>
                          {/*below span is commented as per task jira 229*/}
                          {/*<span>Add Data</span>*/}
                          {tabSelect.id === metric.id &&
                          tabSelect.tabId &&
                          tabSelect.tabId != 0 ? (
                            ''
                          ) : (
                            <span className="tooltip-data">
                              Select metric from
                              <br /> dropdown right
                              <br /> above.
                            </span>
                          )}
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="graph-progress-bar no-data">
                {tabSelect.id === metric.id ? (
                  showGraphLabel()
                ) : (
                  <div className="item">
                    <div className="detial-box">
                      <p>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16.375"
                          height="14.153"
                          viewBox="0 0 16.375 14.153"
                        >
                          <path
                            d="M17.567,13.648,11.854,4.175a2.555,2.555,0,0,0-4.3,0L1.837,13.648A2.234,2.234,0,0,0,1.8,15.882a2.51,2.51,0,0,0,2.19,1.266H15.414a2.51,2.51,0,0,0,2.19-1.236A2.234,2.234,0,0,0,17.567,13.648ZM9.7,14.169a.745.745,0,1,1,.745-.745A.745.745,0,0,1,9.7,14.169Zm.745-2.979a.745.745,0,1,1-1.49,0V8.211a.745.745,0,1,1,1.49,0Z"
                            transform="translate(-1.519 -2.996)"
                          ></path>
                        </svg>{' '}
                        No Test Data Available
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="edit-graph-flex">
              {isEdit && (
                <div className="title-text">
                  Edit{' '}
                  {tabSelect && tabSelect.tabData && tabSelect.tabData.tabname
                    ? tabSelect.tabData.tabname
                    : ''}{' '}
                  Data
                </div>
              )}
              {tabSelect.tabId &&
              tabSelect.id === metric.id &&
              tabSelect.tabId != 0 ? (
                <div className="button-box">
                  <a
                    className="btn gray"
                    onClick={() => {
                      editHandler();
                      AddAnotherDataBar();
                    }}
                  >
                    {tabSelect.tabData &&
                    tabSelect.tabData.statmatrixdetailsstatMatrixmappingidMap &&
                    tabSelect.tabData.statmatrixdetailsstatMatrixmappingidMap
                      .Statmatrixdetails &&
                    tabSelect.tabData.statmatrixdetailsstatMatrixmappingidMap
                      .Statmatrixdetails.length !== 0
                      ? 'Add Another Data Bar'
                      : 'Add Data'}
                  </a>
                </div>
              ) : (
                ''
              )}
            </div>
            {!isEdit && tabSelect.tabId && (
              <div className="graph-edit-button">
                {metric.statmatrixmappingStatsmatrixIdMap &&
                metric.statmatrixmappingStatsmatrixIdMap.Statmatrixmappings
                  ? metric.statmatrixmappingStatsmatrixIdMap.Statmatrixmappings.map(
                      (item) => {
                        if (tabSelect.tabId == item.id) {
                          return (
                            <button
                              className="edit-button green"
                              key={item.id}
                              onClick={(e) => {
                                onChangeHandler(e, 'tabname', metric, item.id);
                              }}
                            >
                              <span>
                                {item.tabname}

                                {showCheckMark() && (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="15.999"
                                    height="11.999"
                                    viewBox="0 0 15.999 11.999"
                                  >
                                    <path
                                      id="checked"
                                      d="M0,70.953l5.479,5.489L16,65.932l-1.51-1.489-9.01,9L1.489,69.453Z"
                                      transform="translate(0 -64.443)"
                                    ></path>
                                  </svg>
                                )}
                              </span>
                            </button>
                          );
                        }
                      }
                    )
                  : ''}
              </div>
            )}
          </div>
        </div>
      );
    });
  };
  return (
    <>
      <div id="MetricsSection" className="stats-box-item">
        <h4 className="title">Metrics</h4>
        <InlineLoader open={props.allStatMetricDetailsList.loading} />
        <div className="stats-toggle-wrapper">{getMetricsList()}</div>
      </div>
      <Dialog
        open={showAddModal}
        onClose={(event, reason) => {
          if (reason == 'backdropClick' || reason == 'escapeKeyDown') {
            showAddModalHandler();
          }
        }}
        className="matDialogCustom"
      >
        <AddYardModalMetrics
          onClose={showAddModalHandler}
          tabData={tabSelect}
          onSave={onSaveHandler}
          isEdit={isEdit}
          handleEdit={editHandler}
          isAdd={isAdd}
          metricData={metricSelect}
          onDelete={onDeleteHandler}
        />
      </Dialog>
      <Dialog
        open={showAddVideoModal}
        onClose={(event, reason) => {
          if (reason == 'backdropClick' || reason == 'escapeKeyDown') {
            showAddVideoModalHandler();
          }
        }}
        className="matDialogCustom"
      >
        <UploadVideoModal
          onClose={showAddVideoModalHandler}
          tabData={tabSelect}
          metricData={metricSelect}
          refreshAfterSave={refreshAfterSave}
          saveStatsMatrixDetailsStart={props.saveStatsMatrixDetailsStart}
          saveVideoPhotoStart={props.saveVideoPhotoStart}
          loading={props.saveStatsMatrixDetails.loading}
        />
      </Dialog>
      <Dialog
        open={showDeleteVideoModal}
        onClose={(event, reason) => {
          if (reason == 'backdropClick' || reason == 'escapeKeyDown') {
            showDeleteVideoModalHandler();
          }
        }}
        className="matDialogCustom"
      >
        <DeleteVideoModal
          onClose={showDeleteVideoModalHandler}
          onDelete={onDeleteVideoHandler}
        />
      </Dialog>
      <Dialog
        open={showVideoReviewPopup}
        onClose={(event, reason) => {
          if (reason == 'backdropClick' || reason == 'escapeKeyDown') {
            setShowVideoReviewPopup(false);
          }
        }}
        className="matDialogCustom"
      >
        <UploadedVideoReview
          onClose={() => setShowVideoReviewPopup(false)}
          metricData={metricSelect}
          isAuth={1}
          page={'Show_Stats_PR'}
          onClickUpdatePopReview={onClickUpdatePopReview}
          onClickDeletePersonal={() => onClickDeleteVidPhoto()}
        />
      </Dialog>
      <Dialog
        open={openLinkPop}
        onClose={(event, reason) => {
          if (reason == 'backdropClick' || reason == 'escapeKeyDown') {
            setOpenLinkPop(false);
          }
        }}
        className="matDialogCustom"
      >
        <WebLinkModal
          tableName={
            matData?.statmatrixdetailsstatmatrixmappingidmaprel
              ?.Statmatrixmappings?.[0]?.tabname
          }
          onClose={() => {
            setOpenLinkPop(false); //state for popup
          }}
          matWebLick={webLinkState} //weblink state
          onHandleWebLink={setWebLinkState} //handle for weblink
          onClickDone={onClickDone} //fun for saving the weblink
          isValid={isValid} //validation state
          setIsValid={setIsValid} //validation state handle
          matData={matData}
          setIsDelPop={setIsDelPop} //func for closing delete popup
        />
      </Dialog>
      <Dialog open={isDelPop}>
        <DeleteWeblinkModal
          onClickCancel={() => setIsDelPop(false)}
          onClickDelete={onClickDone}
        />
      </Dialog>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    allMetricList: state.athlete.editUserProfileData.allMetrics,
    allStatMetricDetailsList:
      state.athlete.editUserProfileData.allStatMetricsDetails,
    saveStatsMatrixDetails:
      state.athlete.editUserProfileData.saveStatsMatrixDetails,
    athleteHeightWeight: state.athlete.onBoarding.athleteHeightWeight,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    allMetricListStart: (data) => dispatch(allMetricsListStart(data)),
    allStatMetricDetailsStart: (data) =>
      dispatch(allStatMatricDetailsListStart(data)),
    statMetricDetailsSave: (data) =>
      dispatch(allStatMatricDetailsListSave(data)),
    saveStatsMatrixDetailsStart: (data) =>
      dispatch(saveStatsMatrixDetailsStart(data)),
    saveVideoPhotoStart: (data) => dispatch(saveVideoPhotoStart(data)),
    athleteHeightWeightStart: (data) =>
      dispatch(athleteHeightWeightStart(data)),
    athleteHeightWeightSaveStart: (data) =>
      dispatch(athleteHeightWeightSaveStart(data)),
    saveOnboardingStart: (data) => dispatch(saveOnboardingStart(data)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Metrics);
